// Component for checkbox
import * as React from "react";
import { useTranslation } from "react-i18next";
import { TierContext } from "tiers/context";
export const Checkbox = (props) => {
    var _a;
    return (React.createElement("input", { type: "checkbox", className: "custom-control-input", ref: el => el && (el.indeterminate = (props.value === undefined)), id: props.id, checked: (_a = props.value) !== null && _a !== void 0 ? _a : false, disabled: props.disabled, onChange: e => props.onCheckedChange(e.target.checked) }));
};
export const LabelledCheckbox = (props) => {
    const tiers = React.useContext(TierContext);
    const { t } = useTranslation();
    let disableCheckbox = !tiers.allow(props) && props.allowWhenLocked !== true;
    let className = "custom-control " + (props.useSwitch ? "custom-switch" : "custom-checkbox");
    let onClick = disableCheckbox ? () => tiers.popup("PP:" + props.id) : undefined;
    return React.createElement("div", { className: className, onClick: onClick },
        React.createElement(Checkbox, Object.assign({}, props, { id: props.id, key: props.id, disabled: disableCheckbox })),
        React.createElement("label", { key: "label", className: "custom-control-label", htmlFor: props.id },
            props.label ? t(["props." + props.label, props.label], props.label) : "",
            tiers.badge(props, "ml-1") /* Display badge if locked. */));
};
export const LabelledCheckboxGroup = (props) => (React.createElement("div", null, props.checkboxes.map(c => React.createElement(LabelledCheckbox, Object.assign({}, c, { key: c.id })))));
